module.exports = __webpack_public_path__ + "static/img/brees-2019-slide-3.1f1ce0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-slide-3.jpg
// module id = ZASD
// module chunks = 1